<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <div class="col-lg-12">
      <mat-tab-group
        [selectedIndex]="selected"
        (selectedIndexChange)="selected = $event"
        *ngIf="!loading"
        #tabGroup
      >
        <mat-tab *ngFor="let card of cardArray; index as i">
          <ng-template mat-tab-label>
            <span [class.mat-error]="hasErrors(undefined, i)">{{
              card.controls.type.value
            }}</span>
          </ng-template>

          <section [formGroup]="card">
            <!-- General Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title [class.mat-error]="hasErrors('enableCards')"
                  >General</mat-panel-title
                >
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <section>
                <section formGroupName="identity">
                  <section formGroupName="label">
                    <mat-form-field
                      class="col-md-2"
                      *ngFor="let lang of availableLangs"
                    >
                      <mat-label>Title {{ lang | uppercase }}</mat-label>
                      <input
                        matInput
                        type="text"
                        formControlName="{{ lang }}"
                      />
                    </mat-form-field>
                  </section>

                  <mat-form-field class="col-md-1" hintLabel="">
                    <mat-label>Icon</mat-label>
                    <mat-select formControlName="icon">
                      <mat-option *ngFor="let icon of icons" [value]="icon">
                        <span class="{{ icon }}"> {{ icon }}</span>
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span
                    class="{{ card.controls.identity.controls.icon.value }}"
                  ></span>
                </section>

                <mat-form-field class="col-md-2" hintLabel="">
                  <mat-label>Code Type</mat-label>
                  <mat-select formControlName="barcode" required>
                    <mat-option
                      *ngFor="let cardCodeType of cardCodeTypes"
                      [value]="cardCodeType"
                    >
                      {{ cardCodeType }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-form-field class="col-md-4" hintLabel="">
                  <mat-label>Life Span (months)</mat-label>
                  <input matInput type="number" formControlName="lifespan" />
                </mat-form-field>

                <mat-form-field class="col-md-4" hintLabel="">
                  <mat-label>Renewal Delay (months)</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="renewalDelay"
                  />
                </mat-form-field>

                <mat-form-field
                  class="col-md-3"
                  hintLabel=""
                  appearance="standard"
                >
                  <mat-label>Start Sequence</mat-label>
                  <input
                    matInput
                    type="string"
                    formControlName="startSequence"
                    placeholder="100000"
                  />
                </mat-form-field>

                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Prefix</mat-label>
                  <input matInput type="text" formControlName="prefix" />
                </mat-form-field>

                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Suffix</mat-label>
                  <input matInput type="text" formControlName="suffix" />
                </mat-form-field>

                <mat-form-field appearance="fill" class="col-md-3">
                  <mat-label [class.mat-error]="hasErrors('enableCards')"
                    >Enable Cards</mat-label
                  >
                  <mat-select multiple formControlName="enableCards">
                    <mat-option
                      *ngFor="
                        let cardType of getCardTypes(card.controls.type.value)
                      "
                      [value]="cardType"
                    >
                      {{ cardType }}
                    </mat-option>
                  </mat-select>
                  <mat-hint class="mat-error" *ngIf="hasErrors('enableCards')"
                    >This card is required and should enable the associated
                    card(s).</mat-hint
                  >
                </mat-form-field>
                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Regex</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="regex"
                    readonly
                  />
                </mat-form-field>

                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Regex Barcode</mat-label>
                  <input
                    matInput
                    type="text"
                    formControlName="regexBarcode"
                    readonly
                  />
                </mat-form-field>
                <div class="row">
                  <mat-label>Linkable</mat-label>
                  <mat-slide-toggle
                    formControlName="linkable"
                    [disabled]="true"
                    class="col-md-2"
                  ></mat-slide-toggle>
                  <mat-label>Link Syst Ext</mat-label>
                  <mat-slide-toggle
                    formControlName="linkSystExt"
                    [disabled]="true"
                    class="col-md-2"
                  ></mat-slide-toggle>
                  <mat-label>Auto Approve</mat-label>
                  <mat-slide-toggle
                    formControlName="autoApprove"
                    [disabled]="true"
                    class="col-md-2"
                  ></mat-slide-toggle>
                  <mat-label>Sequence Generator</mat-label>
                  <mat-slide-toggle
                    formControlName="sequenceGenerator"
                    [disabled]="true"
                    class="col-md-2"
                  ></mat-slide-toggle>
                  <mat-label>Connected</mat-label>
                  <mat-slide-toggle
                    formControlName="isConnected"
                    [disabled]="true"
                    class="col-md-2"
                  ></mat-slide-toggle>
                </div>
              </section>
            </mat-expansion-panel>

            <!-- Subtypes Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Subtypes</mat-panel-title>
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <app-card-subtype
                [card]="card"
                (eventClicked)="childEventClicked($event)"
              ></app-card-subtype>
            </mat-expansion-panel>

            <!-- Required cards Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title [class.mat-error]="hasErrors('requiredCards')"
                  >Required Cards</mat-panel-title
                >
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <app-required-card
                [card]="card"
                [subTypeEvent]="clickedEvent"
                [hasError]="hasErrors('requiredCards')"
              >
              </app-required-card>
            </mat-expansion-panel>

            <!-- Attachments Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Attachments</mat-panel-title>
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <mat-form-field class="col-md-2">
                <mat-label>Minimum Amount</mat-label>
                <input
                  matInput
                  type="number"
                  formControlName="proofOfIdentityCount"
                />
              </mat-form-field>
            </mat-expansion-panel>

            <!-- Default texts Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Default Texts</mat-panel-title>
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <mat-tab-group>
                <mat-tab
                  label="{{ lang | uppercase }}"
                  *ngFor="let lang of availableLangs"
                >
                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3>Introduction</h3>
                      </mat-panel-title>
                      <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="identity">
                      <section formGroupName="instructions">
                        <section formGroupName="general">
                          <section formGroupName="introduction">
                            <quill-editor
                              class="w-100"
                              formControlName="{{ lang }}"
                              placeholder="Entrez votre texte ici..."
                            >
                            </quill-editor>
                          </section>
                        </section>
                      </section>
                    </section>
                  </mat-expansion-panel>

                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3>Card Subscription instructions</h3>
                      </mat-panel-title>
                      <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="identity">
                      <section formGroupName="instructions">
                        <section formGroupName="steps">
                          <section formGroupName="info">
                            <quill-editor
                              class="w-100"
                              formControlName="{{ lang }}"
                              placeholder="Entrez votre texte ici..."
                            >
                            </quill-editor>
                          </section>
                        </section>
                      </section>
                    </section>
                  </mat-expansion-panel>

                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3>Supporting Documents</h3>
                      </mat-panel-title>
                      <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="tooltips">
                      <section formGroupName="subscribe">
                        <quill-editor
                          class="w-100"
                          formControlName="{{ lang }}"
                          placeholder="Entrez votre texte ici..."
                        >
                        </quill-editor>
                      </section>
                    </section>
                  </mat-expansion-panel>

                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3>Confirmation</h3>
                      </mat-panel-title>
                      <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="identity">
                      <section formGroupName="instructions">
                        <section formGroupName="steps">
                          <section formGroupName="confirmation">
                            <quill-editor
                              class="w-100"
                              formControlName="{{ lang }}"
                              placeholder="Entrez votre texte ici..."
                            >
                            </quill-editor>
                          </section>
                        </section>
                      </section>
                    </section>
                  </mat-expansion-panel>

                  <mat-expansion-panel>
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <h3>Text Under 'Subscribe' Button</h3>
                      </mat-panel-title>
                      <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <section formGroupName="identity">
                      <section formGroupName="instructions">
                        <section formGroupName="steps">
                          <section formGroupName="info">
                            <quill-editor
                              class="w-100"
                              formControlName="{{ lang }}"
                              placeholder="Entrez votre texte ici..."
                            >
                            </quill-editor>
                          </section>
                        </section>
                      </section>
                    </section>
                  </mat-expansion-panel>
                </mat-tab>
              </mat-tab-group>
            </mat-expansion-panel>

            <!-- External systems Section -->
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>External systems</mat-panel-title>
                <mat-panel-description></mat-panel-description>
              </mat-expansion-panel-header>
              <section>
                <div class="col-md-12"></div>
              </section>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>Dynamic suffix handler</mat-panel-title>
              </mat-expansion-panel-header>
              <section class="flex-col" formGroupName="dynamicSuffixHandler">
                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Suffix par défaut</mat-label>
                  <input
                    matInput
                    type="string"
                    formControlName="defaultValue"
                  />
                </mat-form-field>

                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label>Longueur du suffix</mat-label>
                  <input
                    matInput
                    type="number"
                    formControlName="suffixLength"
                  />
                </mat-form-field>

                <mat-form-field class="col-md-6" hintLabel="">
                  <mat-label
                    >Connecteur ayant la priorité sur le suffix</mat-label
                  >
                  <mat-select formControlName="codeConnectorPriority">
                    <mat-option
                      *ngFor="let connector of connectorTags"
                      [value]="connector"
                    >
                      <span class="{{ connector }}"> {{ connector }}</span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </section>
            </mat-expansion-panel>
          </section>
        </mat-tab>
        <mat-tab disabled>
          <ng-template mat-tab-label>
            <button
              class="addCardButton"
              mat-button
              (click)="openCreateCardDialog()"
            >
              Add
              <mat-icon>add_circle</mat-icon>
            </button>
          </ng-template>
        </mat-tab>
      </mat-tab-group>

      <div class="save-form-button-container">
        <button
          mat-raised-button
          [disabled]="loading"
          (click)="submit()"
          color="primary"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</section>
